export function formatTeamRole(role: string): string {
  const expanded =
    role === "swe"
      ? "software engineer"
      : role === "pm"
        ? "product manager"
        : role === "qa"
          ? "quality assurance"
          : role.replaceAll("_", " ");
  return expanded.replace(/\b\w/g, (letter) => letter.toUpperCase());
}
